var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShortView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5200_42345)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.799805 13.2362V2.76344C0.799805 2.24265 1.00669 1.74319 1.37494 1.37494C1.74319 1.00669 2.24265 0.799805 2.76344 0.799805H13.2362C13.757 0.799805 14.2564 1.00669 14.6247 1.37494C14.9929 1.74319 15.1998 2.24265 15.1998 2.76344V13.2362C15.1998 13.757 14.9929 14.2564 14.6247 14.6247C14.2564 14.9929 13.757 15.1998 13.2362 15.1998H2.76344C2.24265 15.1998 1.74319 14.9929 1.37494 14.6247C1.00669 14.2564 0.799805 13.757 0.799805 13.2362ZM2.1089 2.76344L2.1089 13.2362C2.1089 13.4098 2.17786 13.5762 2.30061 13.699C2.42336 13.8218 2.58985 13.8907 2.76344 13.8907H6.83617L6.83617 2.1089L2.76344 2.1089C2.58984 2.1089 2.42336 2.17786 2.30061 2.30061C2.17786 2.42336 2.1089 2.58985 2.1089 2.76344ZM10.4725 2.1089V13.8907H8.14526L8.14526 2.1089L10.4725 2.1089ZM13.8907 13.2362C13.8907 13.4098 13.8218 13.5762 13.699 13.699C13.5763 13.8218 13.4098 13.8907 13.2362 13.8907H11.7816V2.1089H13.2362C13.4098 2.1089 13.5763 2.17786 13.699 2.30061C13.8218 2.42336 13.8907 2.58984 13.8907 2.76344V13.2362Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5200_42345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortView);
export default __webpack_public_path__ + "static/media/shortView.117b71ae2bc6fbc57824b8d29a633c9b.svg";
export { ForwardRef as ReactComponent };